import React, { useState } from 'react'
import IconsTextNavigation from 'components/global/IconsTextNavigation'
import SecurityModal from 'pages/Events/Views/Common/Modals/SecurityModal'
import { leagueEventStore } from 'state/league/leagueEvent'

const Security: React.FC = () => {
  const [openSecurityModal, setOpenSecurityModal] = useState<boolean>(false)
  const { riskLevel, setRiskLevel, leagueData } = leagueEventStore(store => ({
    leagueData: store.leagueData,
    riskLevel: store.riskLevel,
    setRiskLevel: store.setRiskLevel,
  }))

  return (
    <>
      <div onClick={() => setOpenSecurityModal(true)}>
        <IconsTextNavigation
          iconName="ShieldCheck"
          heading="Security"
          isCompleted={riskLevel}
        />
      </div>
      {openSecurityModal && (
        <SecurityModal
          openModal={openSecurityModal}
          closeModal={setOpenSecurityModal}
          riskLevel={riskLevel}
          setRiskLevel={setRiskLevel}
        />
      )}
    </>
  )
}

export default Security
